/* eslint-disable no-undef */
import { compose } from 'recompose';
import React from 'react';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { Row } from 'angieslist-react-components';
import BusinessList from './BusinessListPage';
import UnifiedBusinessListView from './UnifiedBusinessListView';
import withBusinessListFeatureFlaggedPageConfig from './withBusinessListFeatureFlaggedPageConfig';

export default compose(withBusinessListFeatureFlaggedPageConfig)(({
  experiment, ...props
}) => (
  <Loader
    element={
      <Row className="category-row text-center" style={{ marginTop: '1em' }}>
        <i className="icon icon-load icon-spin icon-3x text-primary" />
      </Row>}
    loading={Object.keys(experiment.experiments).length === 0}
  >
    <Choose>
      <When condition={experiment.experiments?.unifiedBusinessList?.enabled}>
        <BusinessList {...props} />
      </When>
      <Otherwise>
        <UnifiedBusinessListView {...props} />
      </Otherwise>
    </Choose>
  </Loader >
));




// WEBPACK FOOTER //
// ./src/modules/home/browser/BusinessListFeatureFlaggedPage.js